const MOBILE_USER_AGENT = /iPhone|iPod|Android.*Mobile|Windows Phone|webOS|BlackBerry|IEMobile|Opera Mini|Mobile/i;
const TABLET_USER_AGENT = /iPad|Tablet|Android(?!.*Mobile)/i;

export function getRequestUserAgent(nuxtApp) {
  if (typeof window !== "undefined") {
    return String(window.navigator?.userAgent || "");
  }

  const headers = nuxtApp?.ssrContext?.event?.node?.req?.headers || {};
  return String(headers["user-agent"] || headers["User-Agent"] || "");
}

export function getViewportWidthByUserAgent(userAgent) {
  const normalizedUserAgent = String(userAgent || "");

  if (MOBILE_USER_AGENT.test(normalizedUserAgent)) {
    return 375;
  }
  if (TABLET_USER_AGENT.test(normalizedUserAgent)) {
    return 768;
  }
  return 1200;
}

export function shouldUseUserAgentViewport(nuxtApp) {
  return typeof window === "undefined" || !!nuxtApp?.isHydrating;
}
